import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import auth from 'helpers/auth';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import { API, BASE_URL, } from '../../../CONST';
import DownloadBtn from '../../shared/DownloadBtn';
import BaseTable from '../../shared/BaseTable';
import { cellNumOperation, cellOperation, headerOperation } from '../../../helpers/tables';

const CorredorLineaGarantiaList = ({ user, corredor }) => {
  const [ lineas, setLineas ] = useState(null);
  const [ loading, setLoading ] = useState(false);
  const baseUrl = `${BASE_URL}${API.lineasGarantiaIntermediarios}/`;

  useEffect(() => {
    setLoading(true);
    auth.fetch(corredor ? `${baseUrl}?corredor_id=${corredor.id}` : baseUrl)
      .then(setLineas).finally(() => setLoading(false));
  }, [corredor]);

  const xlsxUrl = `${baseUrl}xlsx/`;
  const pdfUrl = `${baseUrl}pdf/`;
  
  const columns = [
      {
        Header: headerOperation('Razón Social Cliente'),
        id: 'cliente',
        accessor: linea => cellOperation(linea.organizacion.nombre, 'left'),
        sortable: false,
        minWidth: 180,
      },
      {
        Header: headerOperation('RUT'),
        id: 'fecha',
        accessor: linea => cellOperation(linea.organizacion.rut),
        sortable: false,
        minWidth: 100,
      },
      {
        Header: headerOperation('Línea (UF)'),
        id: 'balance__linea',
        accessor: linea => cellNumOperation(linea.balance.linea),
        sortable: false,
        minWidth: 150,
      },
      {
        Header: headerOperation('Cúmulo (UF)'),
        id: 'balance__cumulo',
        accessor: linea => cellNumOperation(linea.balance.cumulo),
        minWidth: 140,
        filterable: false,
        sortable: false,
      },
      {
        Header: headerOperation('Cupo Restante (UF)'),
        id: 'estado',
        accessor: linea => cellNumOperation(linea.balance.cupo_restante),
        minWidth: 100,
        filterable: false,
        sortable: false,
      },
      {
        Header: headerOperation('Acciones'),
        id: 'acciones',
        accessor: i => (
          <div
            className="table-cell"
            style={{ textAlign: 'center' }}
          >
            <span title="ver">
              <Link
                to={`/corredor/lineas-garantia/${i.id}`}
                className="table-link policy"
              >
                <FontAwesomeIcon icon={faEye} />
              </Link>
            </span>
          </div>
        ),
        filterable: false,
        sortable: false,
      },
    ];

  return (
    <>
      {!user.is_orsan && (
        <div style={{ display: 'grid', gridTemplateColumns: '500px 700px', alignItems: 'center' }}>
          <div
            style={{
              display: 'grid', gridTemplateColumns: '65px auto', gridGap: '4px 15px',
              paddingLeft: '16px'
            }}
          >
            <div className="orsan-label">Nombre:</div>
            <div className="orsan-value">{user.organization_name}</div>
            <div className="orsan-label">RUT:</div>
            <div className="orsan-value">{user.organization_rut}</div>
          </div>
          <div />
        </div>
      )}
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'auto max-content max-content',
          gridGap: '10px',
          marginBottom: '6px',
        }}
      >
        <div />
        <div>
          <DownloadBtn
            id='xlsx-download'
            text='XLSX'
            tipText='Descargar Planilla Excel'
            url={corredor ? `${xlsxUrl}?corredor_id=${corredor.id}` : xlsxUrl}
          />
        </div>
        <div>
          <DownloadBtn
            id='pdf-download'
            text='PDF'
            tipText='Descargar PDF'
            url={corredor ? `${pdfUrl}?corredor_id=${corredor.id}` : pdfUrl}
          />
        </div>
      </div>
      <BaseTable
        columns={columns}
        data={lineas ? lineas.results : []}
        loading={loading}
        style={{ maxHeight: '63vh' }}
        showBorders
      />
    </>
  );
};

CorredorLineaGarantiaList.propTypes = {
  user: PropTypes.shape({
    organization_name: PropTypes.string,
    organization_rut: PropTypes.string,
    is_orsan: PropTypes.bool,
  }).isRequired,
  corredor: PropTypes.shape({
    id: PropTypes.number,
  })
};

CorredorLineaGarantiaList.defaultProps = {
  corredor: null,
};

const mapStateToProps = state => ({
  user: state.login.user,
});

export default connect(mapStateToProps)(CorredorLineaGarantiaList);
